export default {
  items: [
    {
      name: 'Recurring Jobs',
      url: '/recurring',
      icon: 'icon-clock'
    }, {
      name: 'Presence Management',
      url: '/presence-management',
      icon: 'icon-map'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js